import { render, staticRenderFns } from "./DetailModal.vue?vue&type=template&id=3e0740d2&scoped=true"
import script from "./DetailModal.vue?vue&type=script&lang=js"
export * from "./DetailModal.vue?vue&type=script&lang=js"
import style0 from "./DetailModal.vue?vue&type=style&index=0&id=3e0740d2&prod&scoped=true&lang=less"
import style1 from "./DetailModal.vue?vue&type=style&index=1&id=3e0740d2&prod&scoped=true&lang=less"
import style2 from "./DetailModal.vue?vue&type=style&index=2&id=3e0740d2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0740d2",
  null
  
)

export default component.exports